// components/FilterButton.js

import { useSelector } from "react-redux";
import { PulseLoader } from "react-spinners";

import { getIsLoading } from "../app/filters";

const FilterButton = ({ target, filter = () => {} }) => {
    const isLoading = useSelector(getIsLoading);

    const handleSubmit = () => filter();

    return (
        <div>
            <button 
                onClick={handleSubmit} 
                type="button" 
                className={`bg-lila mt-[1.2rem] px-4 sidebar:py-1 rounded-lg h-[2.3rem] relative border border-[#EEEEEE] text-white font-semibold sidebar:text-lg text-xs text-center w-full hover:bg-purple-600 active:bg-purple-700 active:scale-95 transition-transform ${isLoading ? 'bg-purple-700' : ''}`}
            >
                {isLoading ? <PulseLoader color={'white'} size={8} /> : 'Filtrer'}
            </button>
        </div> 
    );
};

export default FilterButton;
